<template>
  <div class="vx-row">
    <!-- HORIZONTAL LAYOUT -->
    <div class="vx-col w-full mb-base">
      <form @submit.prevent="onSubmit">
        <vx-card name="Create Product">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Bank</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <span class="text-normal text-sm">Bank</span>
              <v-select
                v-model="bank"
                v-validate="'required'"
                label="name"
                item-value="id"
                :options="listBanks"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                name="Bank"
              />
              <span class="text-danger text-sm" v-show="errors.has('Bank')">{{
                errors.first("Bank")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Name</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <span class="text-normal text-sm">{{ countChar(name) }}/100</span>
              <vs-input
                v-validate="'required|max:100'"
                class="w-full"
                v-model="name"
                name="Name"
              />
              <span class="text-danger text-sm" v-show="errors.has('Name')">{{
                errors.first("Name")
              }}</span>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Account Number</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <span class="text-normal text-sm"
                >{{ countChar(account_number) }}/100</span
              >
              <vs-input
                v-validate="'required|max:100'"
                class="w-full"
                v-model="account_number"
                name="AccountNumber"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('AccountNumber')"
                >{{ errors.first("AccountNumber") }}</span
              >
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button class="mr-3 mb-2" button="submit">Submit</vs-button>
            </div>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>

<script>
import QuillCustom from '../template/QuillCustom'
import PreviewJob from '../template/PreviewJob'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import axios from '../../../axios110'
import router from '../../../router'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
export default {
  data() {
    return {
      userAuth: this.$store.state.user,

      name: '',
      account_number: '',

      listBanks: [],
      bank: { id: 1, name: 'BCA' },
      colorAlert: 'primary',
      nameAlert: 'Alert',
      activeAlert: false,
      valueInput: '',


      editorDesc: {
        modules: {
          toolbar: '#desc'
        }
      },
      editorReq: {
        modules: {
          toolbar: '#req'
        }
      },
      editorBenefit: {
        modules: {
          toolbar: '#description'
        }
      },
      content: '',
      colorx: "white",
      popupActive: false,
      lowongan_button_status: true,
      company_button_status: false,
    }
  },
  components: {
    quillEditor,
    'v-select': vSelect,
    Datepicker,
    QuillCustom,
    PreviewJob
  },
  mounted() {
    this.getBank()

  },

  methods: {
    getBank() {
      axios.get('/ecommerce/web/order/bank', {})
        .then(res => {
          if (res.status != 200) {
            console.log(res.status)
          } else {
            console.log(res)
            this.listBanks = res.data

          }


        })
        .catch(error => {
          console.log(error.response)

        })
    },
    countChar(str) {
      return str.length
    },
    limitChar(str) {
      var output = ''
      if (str.length > 100) {
        str = str.substring(0, 100)
        output = str + '...'
      } else {
        output = str
      }
      return output
    },
    format_date(value) {
      // if (value) {
      //   return moment(String(value)).format('YYYY-MM-DD')
      // }

      const d = value
      const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d)
      const mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(d)
      const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d)
      return `${da} ${mo} ${ye}`
    },
    onSubmit() {
      var formData = {

        'store_id': this.userAuth.company.id,
        'bank_id': this.bank.id,
        'name': this.name,
        'account_number': this.account_number,
      }
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()
          axios.post('ecommerce/web/payment_account', formData)
            .then(res => {
              this.acceptAlert('success', 'Berhasil', 'Anda berhasil buat product')
              this.$vs.loading.close()
              router.push('/paymentAccount')

            })
            .catch(error => {
              console.log(error.response)
              this.$vs.loading.close()

              this.acceptAlert('warning', 'Mohon maaf', 'Data yg anda masukkan belum lengkap, silahkan lengkapi data terlebih dahulu!')


            })
        } else {
          this.acceptAlert('warning', 'Mohon maaf', 'Data yg anda masukkan belum lengkap, silahkan lengkapi data terlebih dahulu!')

        }
      })


    },


    acceptAlert(color, name, message) {

      this.$vs.notify({
        color,
        name,
        text: message
      })

    },
  },

}
</script>

